export default {
  shippingProblem: 'Masalah Pengiriman',
  new: 'Baru',
  newProblem: 'Masalah Baru',
  inProcess: 'Dalam Proses',
  resolve: 'Selesaikan',
  resolved: 'Selesai',
  process: 'Proses',
  problem: 'Masalah',
  problemList: 'Daftar Masalah',
  driverResolve: 'Ditangani Driver',
  adminResolve: 'Ditangani Admin FLI/3PL',
  searchText: 'Cari No. Kiriman/Pesanan',
  confirmProcess: 'Apakah anda yakin ingin memproses masalah ini?',
  confirmResolve: 'Apakah Anda yakin ingin menyelesaikan masalah ini?',
  noteInputLabel: 'Catatan:',
  noteInputValidationMsg: 'Catatan penyelesaian diperlukan',
  shippingProblemDetail: 'Detail Masalah Pengiriman',
  on: 'pada',
  note: 'catatan',
  location: 'Lokasi',
  photo: 'Foto',
  noPhoto: 'tidak ada foto',
  solution: 'Solusi',
  solvedAt: 'diselesaikan pada',
  reportedBy: 'dilaporkan oleh',
  resolvedBy: 'oleh',
  shipmentNoCustomerName: 'No. Pesanan - Nama Customer',
}
